import React from "react";
import { Form, CheckBox } from "fw/forms";
import { Col, FormGroup, Row } from "react-bootstrap";
import { Label } from "fw/components";
import { ContentBody, VeteranAppIdHeader } from "areas/shared/components";
import { DocumentUpload } from "areas/shared/controls";
import * as FormManager from 'fw/forms/form/FormManager';
import UploadsConfig from './UploadsConfig/UploadsConfig';

class Articles extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            form: this.props.stepData,
            tooltips: this.props.stepInfo.tooltips
        };
    };

    updatePostData = (form, dirty) => {
        this.handleUploadsNotApplicableChange(form);
        this.setState({ form });
        this.props.onStepChange(form);
    
        if (dirty === true)
          FormManager.dirt(this._form);
      }

      handleUploadsNotApplicableChange = (form) => {
        //check incorporationArticlesUploadDocument
        if (form.incorporationArticlesNotApplicable !== this.state.form.incorporationArticlesNotApplicable){
            this._incorporationArticlesUpload.blankFile(0);
            form.incorporationArticlesStorageToken = this._incorporationArticlesUpload.state.storageToken;
            form.incorporationArticlesFileName = this._incorporationArticlesUpload.state.fileName;
        }
        //check incorporationCertificateUploadDocument
        if (form.incorporationCertificateNotApplicable !== this.state.form.incorporationCertificateNotApplicable){
            this._incorporationCertificateUpload.blankFile(0);
            form.incorporationCertificateStorageToken = this._incorporationCertificateUpload.state.storageToken;
            form.incorporationCertificateFileName = this._incorporationCertificateUpload.state.fileName;
        }
        //check corporateByLawsUploadDocument
        if (form.corporateByLawsNotApplicable !== this.state.form.corporateByLawsNotApplicable){
            this._corporateByLawsUpload.blankFile(0);
            form.corporateByLawsStorageToken = this._corporateByLawsUpload.state.storageToken;
            form.corporateByLawsFileName = this._corporateByLawsUpload.state.fileName;
        }
        //check foreignEntityCertificateUploadDocument
        if (form.foreignEntityCertificateNotApplicable !== this.state.form.foreignEntityCertificateNotApplicable){
            this._foreignEntityCertificateUpload.blankFile(0);
            form.foreignEntityCertificateStorageToken = this._foreignEntityCertificateUpload.state.storageToken;
            form.foreignEntityCertificateFileName = this._foreignEntityCertificateUpload.state.fileName;
        }
        //check officersElectedMinutesUploadDocument
        if (form.officersElectedMinutesNotApplicable !== this.state.form.officersElectedMinutesNotApplicable){
            this._officersElectedMinutesUpload.blankFile(0);
            form.officersElectedMinutesStorageToken = this._officersElectedMinutesUpload.state.storageToken;
            form.officersElectedMinutesFileName = this._officersElectedMinutesUpload.state.fileName;
        }
        //check firstBoardMeetingMinutesUploadDocument
        if (form.firstBoardMeetingMinutesNotApplicable !== this.state.form.firstBoardMeetingMinutesNotApplicable){
            this._firstBoardMeetingMinutesUpload.blankFile(0);
            form.firstBoardMeetingMinutesStorageToken = this._firstBoardMeetingMinutesUpload.state.storageToken;
            form.firstBoardMeetingMinutesFileName = this._firstBoardMeetingMinutesUpload.state.fileName;
        }
        //check mostRecentMeetingMinutesUploadDocument
        if (form.mostRecentMeetingMinutesNotApplicable !== this.state.form.mostRecentMeetingMinutesNotApplicable){
            this._mostRecentMeetingMinutesUpload.blankFile(0);
            form.mostRecentMeetingMinutesStorageToken = this._mostRecentMeetingMinutesUpload.state.storageToken;
            form.mostRecentMeetingMinutesFileName = this._mostRecentMeetingMinutesUpload.state.fileName;
        }
        //check capitalContributionProofUploadDocument
        if (form.capitalContributionProofNotApplicable !== this.state.form.capitalContributionProofNotApplicable){
            this._capitalContributionProofUpload.blankFile(0);
            form.capitalContributionProofStorageToken = this._capitalContributionProofUpload.state.storageToken;
            form.capitalContributionProofFileName = this._capitalContributionProofUpload.state.fileName;
        }
        //check stockPurchaseProofUploadDocument
        if (form.stockPurchaseProofNotApplicable !== this.state.form.stockPurchaseProofNotApplicable){
            this._stockPurchaseProofUpload.blankFile(0);
            form.stockPurchaseProofStorageToken = this._stockPurchaseProofUpload.state.storageToken;
            form.stockPurchaseProofFileName = this._stockPurchaseProofUpload.state.fileName;
        }
        //check corporateStockCertificatesUploadDocument
        if (form.corporateStockCertificatesNotApplicable !== this.state.form.corporateStockCertificatesNotApplicable){
            this._corporateStockCertificatesUpload.blankFile(0);
            form.corporateStockCertificatesStorageToken = this._corporateStockCertificatesUpload.state.storageToken;
            form.corporateStockCertificatesFileName = this._corporateStockCertificatesUpload.state.fileName;
        }
        //check corporateStockLedgerUploadDocument
        if (form.corporateStockLedgerNotApplicable !== this.state.form.corporateStockLedgerNotApplicable){
            this._corporateStockLedgerUpload.blankFile(0);
            form.corporateStockLedgerStorageToken = this._corporateStockLedgerUpload.state.storageToken;
            form.corporateStockLedgerFileName = this._corporateStockLedgerUpload.state.fileName;
        }
        //check operationalAgreementUploadDocument
        if (form.operationalAgreementNotApplicable !== this.state.form.operationalAgreementNotApplicable){
            this._operationalAgreementUpload.blankFile(0);
            form.operationalAgreementStorageToken = this._operationalAgreementUpload.state.storageToken;
            form.operationalAgreementFileName = this._operationalAgreementUpload.state.fileName;
        }
        //check buyOutRightsUploadDocument
        if (form.buyOutRightsNotApplicable !== this.state.form.buyOutRightsNotApplicable){
            this._buyOutRightsUpload.blankFile(0);
            form.buyOutRightsStorageToken = this._buyOutRightsUpload.state.storageToken;
            form.buyOutRightsFileName = this._buyOutRightsUpload.state.fileName;
        }
        //check limitedPartnershipCertificateUploadDocument
        if (form.limitedPartnershipCertificateNotApplicable !== this.state.form.limitedPartnershipCertificateNotApplicable){
            this._limitedPartnershipCertificateUpload.blankFile(0);
            form.limitedPartnershipCertificateStorageToken = this._limitedPartnershipCertificateUpload.state.storageToken;
            form.limitedPartnershipCertificateFileName = this._limitedPartnershipCertificateUpload.state.fileName;
        }
        //check limitedPartnershipDocumentsUploadDocument
        if (form.limitedPartnershipDocumentsNotApplicable !== this.state.form.limitedPartnershipDocumentsNotApplicable){
            this._limitedPartnershipDocumentsUpload.blankFile(0);
            form.limitedPartnershipDocumentsStorageToken = this._limitedPartnershipDocumentsUpload.state.storageToken;
            form.limitedPartnershipDocumentsFileName = this._limitedPartnershipDocumentsUpload.state.fileName;
        }
        //check partnershipAgreementsUploadDocument
        if (form.partnershipAgreementsNotApplicable !== this.state.form.partnershipAgreementsNotApplicable){
            this._partnershipAgreementsUpload.blankFile(0);
            form.partnershipAgreementsStorageToken = this._partnershipAgreementsUpload.state.storageToken;
            form.partnershipAgreementsFileName = this._partnershipAgreementsUpload.state.fileName;
        }
        //check profitSharingUploadDocument
        if (form.profitSharingNotApplicable !== this.state.form.profitSharingNotApplicable){
            this._profitSharingUpload.blankFile(0);
            form.profitSharingStorageToken = this._profitSharingUpload.state.storageToken;
            form.profitSharingFileName = this._profitSharingUpload.state.fileName;
        }
        //check thirdPartyAgreementsUploadDocument
        if (form.thirdPartyAgreementsNotApplicable !== this.state.form.thirdPartyAgreementsNotApplicable){
            this._thirdPartyAgreementsUpload.blankFile(0);
            form.thirdPartyAgreementsStorageToken = this._thirdPartyAgreementsUpload.state.storageToken;
            form.thirdPartyAgreementsFileName = this._thirdPartyAgreementsUpload.state.fileName;
        }
        //check operationalAgreementUploadDocument
        if (form.operationalAgreementNotApplicable !== this.state.form.operationalAgreementNotApplicable){
            this._operationalAgreementUpload.blankFile(0);
            form.operationalAgreementStorageToken = this._operationalAgreementUpload.state.storageToken;
            form.operationalAgreementFileName = this._operationalAgreementUpload.state.fileName;
        }
    }
    
    handleUploadChange = (file, controlName) => {
        let form = this.state.form;
        form[controlName + "StorageToken"] = file.storageToken;
        form[controlName + "FileName"] = file.fileName;
    
        this.updatePostData(form, true);
    };

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        //Default: Corporations documents
        let documentsConfig = UploadsConfig[0];
        if (this.state.form.businessOwnershipId !== null && this.state.form.businessOwnershipId !== undefined )
            documentsConfig = UploadsConfig[this.state.form.businessOwnershipId-1];

        var checkBoxText = "Not Applicable to my Business";
        var notApplicableText = "Please provide a Letter of Explanation on a Corporate Letterhead that is signed and dated as to why it cannot be provided, and upload it in the field above";

        return (
            <div>
                <ContentBody>
                    <Form
                        onChange={this.updatePostData}
                        values={this.state.form}
                        unsavedChangesWarning={true}
                        disabled={this.props.stepInfo.readonly || this.props.stepInfo.isRenewal}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col md={12}>
                                <Row>
                                    <Col md={12}>
                                        <h3 style={{ position: 'relative' }}>Corporate Documents – <small> Please submit all required Corporate Documents as listed below</small> <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                        <hr />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={5}>
                                        { (documentsConfig["IncorporationArticles"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="incorporationArticlesUpload" tip={this.setTip(documentsConfig["IncorporationArticles"].tooltipCode)} required>
                                                    {documentsConfig["IncorporationArticles"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.incorporationArticlesStorageToken}
                                                    fileName={this.state.form.incorporationArticlesFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "incorporationArticles")}
                                                    ref={(c) => { this._incorporationArticlesUpload = c; }}
                                                />
                                                <CheckBox inline name="incorporationArticlesNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.incorporationArticlesNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["IncorporationCertificate"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="incorporationCertificateUpload" tip={this.setTip(documentsConfig["IncorporationCertificate"].tooltipCode)} required>
                                                    {documentsConfig["IncorporationCertificate"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.incorporationCertificateStorageToken}
                                                    fileName={this.state.form.incorporationCertificateFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "incorporationCertificate")}
                                                    ref={(c) => { this._incorporationCertificateUpload = c; }}
                                                />
                                                <CheckBox inline name="incorporationCertificateNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.incorporationCertificateNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["CorporateByLaws"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="corporateByLawsUpload" tip={this.setTip(documentsConfig["CorporateByLaws"].tooltipCode)} required>
                                                    {documentsConfig["CorporateByLaws"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.corporateByLawsStorageToken}
                                                    fileName={this.state.form.corporateByLawsFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "corporateByLaws")}
                                                    ref={(c) => { this._corporateByLawsUpload = c; }}
                                                />
                                                <CheckBox inline name="corporateByLawsNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.corporateByLawsNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["OfficersElectedMinutes"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="officersElectedMinutesUpload" tip={this.setTip(documentsConfig["OfficersElectedMinutes"].tooltipCode)} required>
                                                    {documentsConfig["OfficersElectedMinutes"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.officersElectedMinutesStorageToken}
                                                    fileName={this.state.form.officersElectedMinutesFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "officersElectedMinutes")}
                                                    ref={(c) => { this._officersElectedMinutesUpload = c; }}
                                                />
                                                <CheckBox inline name="officersElectedMinutesNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.officersElectedMinutesNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["FirstBoardMeetingMinutes"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="firstBoardMeetingMinutesUpload" tip={this.setTip(documentsConfig["FirstBoardMeetingMinutes"].tooltipCode)} required>
                                                    {documentsConfig["FirstBoardMeetingMinutes"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.firstBoardMeetingMinutesStorageToken}
                                                    fileName={this.state.form.firstBoardMeetingMinutesFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "firstBoardMeetingMinutes")}
                                                    ref={(c) => { this._firstBoardMeetingMinutesUpload = c; }}
                                                />
                                                <CheckBox inline name="firstBoardMeetingMinutesNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.firstBoardMeetingMinutesNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["MostRecentMeetingMinutes"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="mostRecentMeetingMinutesUpload" tip={this.setTip(documentsConfig["MostRecentMeetingMinutes"].tooltipCode)} required>
                                                    {documentsConfig["MostRecentMeetingMinutes"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.mostRecentMeetingMinutesStorageToken}
                                                    fileName={this.state.form.mostRecentMeetingMinutesFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "mostRecentMeetingMinutes")}
                                                    ref={(c) => { this._mostRecentMeetingMinutesUpload = c; }}
                                                />
                                                <CheckBox inline name="mostRecentMeetingMinutesNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.mostRecentMeetingMinutesNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["BuyOutRights"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="buyOutRightsUpload" tip={this.setTip(documentsConfig["BuyOutRights"].tooltipCode)} required>
                                                    {documentsConfig["BuyOutRights"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.buyOutRightsStorageToken}
                                                    fileName={this.state.form.buyOutRightsFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "buyOutRights")}
                                                    ref={(c) => { this._buyOutRightsUpload = c; }}
                                                />
                                                <CheckBox inline name="buyOutRightsNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.buyOutRightsNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["LimitedPartnershipCertificate"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="limitedPartnershipCertificateUpload" tip={this.setTip(documentsConfig["LimitedPartnershipCertificate"].tooltipCode)} required>
                                                    {documentsConfig["LimitedPartnershipCertificate"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.limitedPartnershipCertificateStorageToken}
                                                    fileName={this.state.form.limitedPartnershipCertificateFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "limitedPartnershipCertificate")}
                                                    ref={(c) => { this._limitedPartnershipCertificateUpload = c; }}
                                                />
                                                <CheckBox inline name="limitedPartnershipCertificateNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.limitedPartnershipCertificateNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["PartnershipAgreements"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="partnershipAgreementsUpload" tip={this.setTip(documentsConfig["PartnershipAgreements"].tooltipCode)} required>
                                                    {documentsConfig["PartnershipAgreements"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.partnershipAgreementsStorageToken}
                                                    fileName={this.state.form.partnershipAgreementsFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "partnershipAgreements")}
                                                    ref={(c) => { this._partnershipAgreementsUpload = c; }}
                                                />
                                                <CheckBox inline name="partnershipAgreementsNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.partnershipAgreementsNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["CapitalContributionProof"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="capitalContributionProofUpload" tip={this.setTip(documentsConfig["CapitalContributionProof"].tooltipCode)} required>
                                                    {documentsConfig["CapitalContributionProof"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.capitalContributionProofStorageToken}
                                                    fileName={this.state.form.capitalContributionProofFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "capitalContributionProof")}
                                                    ref={(c) => { this._capitalContributionProofUpload = c; }}
                                                />
                                                <CheckBox inline name="capitalContributionProofNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.capitalContributionProofNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                    </Col>
                                    <Col md={1} />
                                    <Col md={5}>
                                        { (documentsConfig["ForeignEntityCertificate"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="foreignEntityCertificateUpload" tip={this.setTip(documentsConfig["ForeignEntityCertificate"].tooltipCode)} required>
                                                    {documentsConfig["ForeignEntityCertificate"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.foreignEntityCertificateStorageToken}
                                                    fileName={this.state.form.foreignEntityCertificateFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "foreignEntityCertificate")}
                                                    ref={(c) => { this._foreignEntityCertificateUpload = c; }}
                                                />
                                                <CheckBox inline name="foreignEntityCertificateNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.foreignEntityCertificateNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["StockPurchaseProof"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="stockPurchaseProofUpload" tip={this.setTip(documentsConfig["StockPurchaseProof"].tooltipCode)} required>
                                                    {documentsConfig["StockPurchaseProof"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.stockPurchaseProofStorageToken}
                                                    fileName={this.state.form.stockPurchaseProofFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "stockPurchaseProof")}
                                                    ref={(c) => { this._stockPurchaseProofUpload = c; }}
                                                />
                                                <CheckBox inline name="stockPurchaseProofNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.stockPurchaseProofNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }

                                        { (documentsConfig["CorporateStockCertificates"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="corporateStockCertificatesUpload" tip={this.setTip(documentsConfig["CorporateStockCertificates"].tooltipCode)} required>
                                                    {documentsConfig["CorporateStockCertificates"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.corporateStockCertificatesStorageToken}
                                                    fileName={this.state.form.corporateStockCertificatesFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "corporateStockCertificates")}
                                                    ref={(c) => { this._corporateStockCertificatesUpload = c; }}
                                                />
                                                <CheckBox inline name="corporateStockCertificatesNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.corporateStockCertificatesNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        
                                        { (documentsConfig["CorporateStockLedger"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="corporateStockLedgerUpload" tip={this.setTip(documentsConfig["CorporateStockLedger"].tooltipCode)} required>
                                                    {documentsConfig["CorporateStockLedger"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.corporateStockLedgerStorageToken}
                                                    fileName={this.state.form.corporateStockLedgerFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "corporateStockLedger")}
                                                    ref={(c) => { this._corporateStockLedgerUpload = c; }}
                                                />
                                                <CheckBox inline name="corporateStockLedgerNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.corporateStockLedgerNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["LimitedPartnershipDocuments"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="limitedPartnershipDocumentsUpload" tip={this.setTip(documentsConfig["LimitedPartnershipDocuments"].tooltipCode)} required>
                                                    {documentsConfig["LimitedPartnershipDocuments"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.limitedPartnershipDocumentsStorageToken}
                                                    fileName={this.state.form.limitedPartnershipDocumentsFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "limitedPartnershipDocuments")}
                                                    ref={(c) => { this._limitedPartnershipDocumentsUpload = c; }}
                                                />
                                                <CheckBox inline name="limitedPartnershipDocumentsNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.limitedPartnershipDocumentsNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["ProfitSharing"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="profitSharingUpload" tip={this.setTip(documentsConfig["ProfitSharing"].tooltipCode)} required>
                                                    {documentsConfig["ProfitSharing"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.profitSharingStorageToken}
                                                    fileName={this.state.form.profitSharingFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "profitSharing")}
                                                    ref={(c) => { this._profitSharingUpload = c; }}
                                                />
                                                <CheckBox inline name="profitSharingNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.profitSharingNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["ThirdPartyAgreements"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="thirdPartyAgreementsUpload" tip={this.setTip(documentsConfig["ThirdPartyAgreements"].tooltipCode)} required>
                                                    {documentsConfig["ThirdPartyAgreements"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.thirdPartyAgreementsStorageToken}
                                                    fileName={this.state.form.thirdPartyAgreementsFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "thirdPartyAgreements")}
                                                    ref={(c) => { this._thirdPartyAgreementsUpload = c; }}
                                                />
                                                <CheckBox inline name="thirdPartyAgreementsNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.thirdPartyAgreementsNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                        { (documentsConfig["OperationalAgreement"].visible) &&
                                            <FormGroup>
                                                <Label htmlFor="operationalAgreementUpload" tip={this.setTip(documentsConfig["OperationalAgreement"].tooltipCode)} required>
                                                    {documentsConfig["OperationalAgreement"].description}
                                                </Label>
                                                <DocumentUpload
                                                    storageToken={this.state.form.operationalAgreementStorageToken}
                                                    fileName={this.state.form.operationalAgreementFileName}
                                                    onChange={(file) => this.handleUploadChange(file, "operationalAgreement")}
                                                    ref={(c) => { this._operationalAgreementUpload = c; }}
                                                />
                                                <CheckBox inline name="operationalAgreementNotApplicable" label={checkBoxText} />
                                                {this.state.form !== null && this.state.form.operationalAgreementNotApplicable ? (
                                                    <div>{notApplicableText}</div>
                                                ) : null}
                                            </FormGroup>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </ContentBody>
            </div>
        );
    }
}

export default Articles;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/articles/Articles.js